import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton, Snackbar as MUISnackbar } from '@mui/material';
import React, { FC } from 'react';

import { SnackBarProps } from '../types';

export const Snackbar: FC<SnackBarProps> = ({ showSnackbar, setShowSnackbar }) => (
	<MUISnackbar
		open={!!showSnackbar}
		onClose={showSnackbar?.onClose ? showSnackbar.onClose : () => setShowSnackbar(null)}
		autoHideDuration={showSnackbar?.autoHideDuration === undefined ? 6000 : showSnackbar.autoHideDuration}
		anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
		ClickAwayListenerProps={{ onClickAway: () => null }}
		data-cy='snackbar-container'
	>
		<Alert
			variant='filled'
			severity={showSnackbar?.severity}
			// this style is to override the default color on close of snackbar
			style={showSnackbar ? {} : { display: 'none' }}
			className='pca_main-snackbar'
			action={
				<IconButton
					onClick={showSnackbar?.onClose ? showSnackbar.onClose : () => setShowSnackbar(null)}
					data-cy='snackbar-close-button'
				>
					<CloseIcon style={{ color: 'white' }} />
				</IconButton>
			}
		>
			<div className='snackbar-text' data-cy='snackbar-message-text'>
				{showSnackbar?.message}
			</div>
		</Alert>
	</MUISnackbar>
);
